/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  FacadePvpControllerLib2,
  FacadePvpControllerLib2Interface,
} from "../FacadePvpControllerLib2";

const _abi = [
  {
    inputs: [],
    name: "ErrorNotGuildController",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "heroHasTechnicalDefeat",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "opponentHasTechnicalDefeat",
        type: "bool",
      },
    ],
    name: "_checkTechnicalDefeat",
    outputs: [
      {
        internalType: "bool",
        name: "technicalDefeat",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isHeroWinner",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "points_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "dominationCounter",
        type: "uint256",
      },
    ],
    name: "_getPointsWithPenalty",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "completed",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "totalCountFights",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "healthHero",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "healthOpponent",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "manaConsumedHero",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "manaConsumedOpponent",
            type: "uint32",
          },
        ],
        internalType: "struct IPvpController.PvpFightResults",
        name: "fightResult",
        type: "tuple",
      },
    ],
    name: "_getWinners",
    outputs: [
      {
        internalType: "bool",
        name: "isHeroWinner",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isOpponentWinner",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "week",
        type: "uint32",
      },
    ],
    name: "getBiomeGuilds",
    outputs: [
      {
        internalType: "uint256[]",
        name: "guildIds",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
    ],
    name: "getBiomeOwner",
    outputs: [
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IController",
        name: "controller",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    name: "onGuildDeletion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "week",
        type: "uint32",
      },
      {
        internalType: "uint256[]",
        name: "guildIds",
        type: "uint256[]",
      },
    ],
    name: "setBiomeGuilds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint64",
            name: "guildBiomeOwnerId",
            type: "uint64",
          },
          {
            internalType: "uint32",
            name: "startedEpochWeek",
            type: "uint32",
          },
          {
            internalType: "uint16",
            name: "dominationCounter",
            type: "uint16",
          },
        ],
        internalType: "struct IPvpController.BiomeData",
        name: "data",
        type: "tuple",
      },
    ],
    name: "setBiomeState",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
    ],
    name: "setOwnedBiome",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "setPseudoRandomForTests",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class FacadePvpControllerLib2__factory {
  static readonly abi = _abi;
  static createInterface(): FacadePvpControllerLib2Interface {
    return new Interface(_abi) as FacadePvpControllerLib2Interface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): FacadePvpControllerLib2 {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as FacadePvpControllerLib2;
  }
}
